import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { DotKiemKeTaiSan, DotKiemKeTaiSanRequest, TimKiemDotKiemKeTaiSanRequest } from "../models/taisan/DotKiemKeTaiSan";
import intance from "../utils/axios";

export const timKiemDSDotKiemKe = async (request: TimKiemDotKiemKeTaiSanRequest, start: number, length: number) => {
    var data = {
        data: [] as any[],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.dotKiemKeTaiSan.timKiem, {
        "start": start,
        "length": length,
        "filter": {
            "tuKhoa": request.tuKhoa || "",
            "trangThai": request.trangThai,
            "tuNgay": request.tuNgay,
            "denNgay": request.denNgay
        },
        "orderBy": {
            "columnName": "ngayKhoiTao",
            "isDesc": true
        }
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                const result = res.data.duLieu;
                // Parse idsDSNguoiPhuTrach string "1,2,3" thành mảng number[] cho mỗi item
                if (result && result.data) {
                    result.data = result.data.map((item: any) => {
                        if (item.idsDSNguoiPhuTrach && typeof item.idsDSNguoiPhuTrach === 'string') {
                            item.idsDSNguoiPhuTrach = item.idsDSNguoiPhuTrach
                                .split(',')
                                .map((s: string) => parseInt(s.trim()))
                                .filter((n: number) => !isNaN(n) && n > 0);
                        } else if (!item.idsDSNguoiPhuTrach) {
                            item.idsDSNguoiPhuTrach = [];
                        }
                        return item;
                    });
                }
                data = result;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layChiTietDotKiemKe = async (id: number) => {
    var rs: DotKiemKeTaiSan | null = null;
    await intance.get(ApiPaths.dotKiemKeTaiSan.layChiTiet + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                const data = res.data.duLieu;
                if (data) {
                    // Parse chuỗi idsDSNguoiPhuTrach "1,2,3" thành mảng number[]
                    if (data.idsDSNguoiPhuTrach && typeof data.idsDSNguoiPhuTrach === 'string') {
                        data.idsDSNguoiPhuTrach = data.idsDSNguoiPhuTrach
                            .split(',')
                            .map((s: string) => parseInt(s.trim()))
                            .filter((n: number) => !isNaN(n) && n > 0);
                    } else if (!data.idsDSNguoiPhuTrach) {
                        data.idsDSNguoiPhuTrach = [];
                    }
                }
                rs = data;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuDotKiemKe = async (request: DotKiemKeTaiSanRequest, file?: File | null, isXoaFile?: boolean) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: 0 };
    
    const formData = new FormData();
    if (request.id) formData.append("id", request.id.toString());
    formData.append("maDotKiemKe", request.maDotKiemKe);
    formData.append("tenDotKiemKe", request.tenDotKiemKe);
    formData.append("ngayBatDau", request.ngayBatDau);
    formData.append("ngayKetThuc", request.ngayKetThuc);
    formData.append("trangThai", request.trangThai.toString());
    if (request.moTa) formData.append("moTa", request.moTa);
    
    if (request.idsDSNguoiPhuTrach && request.idsDSNguoiPhuTrach.length > 0) {
        request.idsDSNguoiPhuTrach.forEach(id => {
            formData.append("idsDSNguoiPhuTrach", id.toString());
        });
    }
    
    if (request.idPhoCVP) formData.append("idPhoCVP", request.idPhoCVP.toString());
    if (request.idPhoGiamDoc) formData.append("idPhoGiamDoc", request.idPhoGiamDoc.toString());
    if (request.idChanhVP) formData.append("idChanhVP", request.idChanhVP.toString());
    if (request.idGiamDoc) formData.append("idGiamDoc", request.idGiamDoc.toString());
    if (request.jsonDsThanhVien) formData.append("jsonDsThanhVien", request.jsonDsThanhVien);
    
    if (file) {
        formData.append("file", file);
    }
    if (isXoaFile) {
        formData.append("isXoaFile", "true");
    }

    await intance.post(ApiPaths.dotKiemKeTaiSan.luu, formData, {
        headers: { "Content-Type": "multipart/form-data" }
    })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const xoaDotKiemKe = async (id: number) => {
    await intance.get(ApiPaths.dotKiemKeTaiSan.xoa + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                // Success
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const capNhatTrangThaiDotKiemKe = async (id: number, trangThai: number) => {
    await intance.post(ApiPaths.dotKiemKeTaiSan.capNhatTrangThai, { id, trangThai })
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const trinhDuyetDotKiemKe = async (id: number) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    await intance.post(ApiPaths.dotKiemKeTaiSan.trinhDuyet, { id })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const thuHoiDotKiemKe = async (id: number, lyDo: string) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    await intance.post(ApiPaths.dotKiemKeTaiSan.thuHoi, { id, lyDo })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};

export const pheDuyetDotKiemKe = async (id: number, isDuyet: boolean, lyDo?: string) => {
    var response = { trangThai: responseStatus.loi, thongBao: "", duLieu: false };
    await intance.post(ApiPaths.dotKiemKeTaiSan.pheDuyet, { id, isDuyet, lyDo })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
            throw err;
        });
    return response;
};
